import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import { useGetUserDataQuery } from "../../services/login";
import HelmetComponent from "../../Components/HelmetComponent";

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
function ShippingPolicy() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  return (
    <>
      <HelmetComponent title={"Shipping Policy"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ fontSize: "1.4rem" }}>Shipping Policy</h1>

                <h4>1. Overview</h4>
                <p>
                  At <strong>TheGlobalGenie.com</strong>, our goal is simple – you place the order, and we quietly
                  handle everything in between until it safely reaches your doorstep. We work with trusted suppliers,
                  warehouses, and courier partners so your experience stays smooth, transparent, and hassle-free.
                </p>

                <h4>2. Shipping Process</h4>
                <p>Once you confirm your order:</p>
                <ul>
                  <li>Our team coordinates with verified suppliers and courier partners.</li>
                  <li>Your products are carefully checked, packed, and dispatched to the address you provide.</li>
                  <li>
                    We oversee the journey from dispatch to delivery and step in wherever needed to ensure everything
                    stays on track.
                  </li>
                </ul>

                <h4>3. Shipping Charges</h4>
                <ul>
                  <li>Standard shipping is free for all customers, subject to a fair usage policy.</li>
                  <li>
                    Oversized, heavy, or special-handling items may incur additional shipping or handling charges.
                  </li>
                  <li>
                    If extra charges apply, we will inform you upfront. You may accept the charges or cancel the order
                    before processing.
                  </li>
                </ul>

                <h4>4. Order Tracking</h4>
                <p>Once your order is shipped:</p>
                <ul>
                  <li>You will receive an email with courier details and a tracking ID.</li>
                  <li>Use this tracking ID to monitor the shipment online.</li>
                  <li>
                    For help with tracking, contact our support team via Live Chat, Email, or Phone (details are in our
                    Contact Us section).
                  </li>
                </ul>

                <h4>5. Delivery to Your Door</h4>
                <p>We aim to deliver directly to your doorstep using trusted courier partners.</p>
                <ul>
                  <li>
                    If the outer packaging is visibly damaged, please refuse the shipment and notify us immediately.
                  </li>
                  <li>
                    If damage is discovered later, contact us within 2 days of delivery with photos/videos for
                    assistance.
                  </li>
                </ul>

                <h4>6. Customs & Import Clearance</h4>
                <p>
                  Since TheGlobalGenie deals with cross-border orders, customs rules may apply depending on your
                  country:
                </p>
                <ul>
                  <li>In most cases, we handle customs clearance so you do not pay extra duties unless specified.</li>
                  <li>We will inform you if your country needs licenses or special documentation.</li>
                  <li>If an item is prohibited or restricted, we will cancel those items and issue a full refund.</li>
                </ul>

                <p>
                  <strong>Please note:</strong>
                </p>
                <ul>
                  <li>The recipient is the Importer of Record and must ensure the item is legal to import.</li>
                  <li>Authorities may request documents—your cooperation may be required.</li>
                  <li>Certain products may require licenses or end-user declarations before release from customs.</li>
                </ul>

                <h4>7. Shipping Delays</h4>
                <p>Delays may occur due to:</p>
                <ul>
                  <li>Bad weather or natural calamities</li>
                  <li>Flight delays or logistical issues</li>
                  <li>National holidays, strikes, or festivals</li>
                  <li>Customs inspections</li>
                  <li>Health emergencies or other unforeseen events</li>
                </ul>
                <p>We will keep you informed of major delays and work to resolve them as quickly as possible.</p>

                <h4>8. Prohibited & Restricted Items</h4>
                <ul>
                  <li>Products are subject to export/import laws of both origin and destination countries.</li>
                  <li>Some items may be restricted or prohibited in certain regions—please verify before ordering.</li>
                  <li>If customs confiscates or destroys restricted goods, we cannot issue refunds for those items.</li>
                </ul>

                <h4>9. Undeliverable & Refused Shipments</h4>
                <p>A shipment may be returned if:</p>
                <ul>
                  <li>The address is incorrect or incomplete</li>
                  <li>Delivery attempts fail repeatedly</li>
                  <li>You refuse delivery</li>
                  <li>Duties/taxes remain unpaid (where applicable)</li>
                  <li>Customs or regulatory issues occur</li>
                </ul>
                <p>
                  Refunds for returned shipments will be processed after deducting return shipping charges, customs
                  fees, and any other applicable costs. The refundable amount will be communicated after assessment.
                </p>

                <h4>10. Need Help with Your Shipment?</h4>
                <p>
                  Our support team is here to ensure a smooth shipping experience. If you have any questions at any
                  stage of your order, please contact us using the details available on our Contact Us page.
                </p>

                <div style={{ lineHeight: 2 }}>
                  <p>
                    {" "}
                    <strong>TheGlobalGenie Ecommerce Private Limited</strong>
                  </p>
                  <p>
                    <strong>India Operations and Support</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: Host?.address,
                      }}
                    ></div>
                    <MailOutlineIcon style={{ fontSize: "1.1rem", color: "#444" }} />
                    &nbsp; {Host?.email} <br />
                    <PhoneIcon style={{ fontSize: "1.1rem", color: "#444" }} />
                    &nbsp; {Host?.phone}
                  </p>

                  <p>
                    <strong>Global Operations and Support</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: Host?.addressGlobal,
                      }}
                    ></div>
                    <MailOutlineIcon style={{ fontSize: "1.1rem", color: "#444" }} />
                    &nbsp; {Host?.emailGlobal} <br />
                    <PhoneIcon style={{ fontSize: "1.1rem", color: "#444" }} />
                    &nbsp; {Host?.phoneGlobal}
                  </p>
                </div>

                <p>
                  Thank you for choosing <strong>TheGlobalGenie</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShippingPolicy;
